(function () {

function render_size_calculator (previous_cont) {
  if (window_api_data.product_type == "MENS WETSUIT") {
    window_api_data.product_type = "MENS WETSUITS"
  }
  else if (window_api_data.product_type == "WOMENS") {
    window_api_data.product_type = "WOMENS WETSUITS"
    //if (window.location.pathname == "/products/womens-4-3-chest-zip-wetsuit" || window.location.pathname == "/products/womens-3-2-chest-zip-wetsuit") {
    //  window_api_data.product_type = "WOMENS WETSUITS EXTRA"
    //}
  }
  else if (window_api_data.product_type == "YOUTH WETSUITS") {
    window_api_data.product_type = "KIDS WETSUITS"
  }

  const size_scale = 'Metric' //  Imperial for USA

  const contact_url = window_api_data.root_url + ((size_scale == 'Metric') ? '/pages/contact-us/' : '/pages/frontpage');

  const all_size_calculator_data = {
    "MENS WETSUITS": {
      "L": { "height-max": 185, "height-min": 180, "weight-max": 86, "weight-min": 78 },
      "LS": { "height-max": 179, "height-min": 174, "weight-max": 86, "weight-min": 78 },
      "LT": { "height-max": 191, "height-min": 186, "weight-max": 86, "weight-min": 78 },
      "M": { "height-max": 179, "height-min": 174, "weight-max": 77, "weight-min": 68 },
      "MS": { "height-max": 173, "height-min": 168, "weight-max": 77, "weight-min": 68 },
      "MT": { "height-max": 185, "height-min": 180, "weight-max": 77, "weight-min": 68 },
      "S": { "height-max": 173, "height-min": 168, "weight-max": 68, "weight-min": 58 },
      "XL": { "height-max": 191, "height-min": 186, "weight-max": 97, "weight-min": 87 },
      "XLS": { "height-max": 185, "height-min": 180, "weight-max": 97, "weight-min": 87 },
      "XLT": { "height-max": 200, "height-min": 192, "weight-max": 97, "weight-min": 87 },
      "XS": { "height-max": 167, "height-min": 159, "weight-max": 60, "weight-min": 55 },
      "ST": { "height-max": 179, "height-min": 174, "weight-max": 67, "weight-min": 58 },
      "XXL": { "height-max": 200, "height-min": 192, "weight-max": 110, "weight-min": 97 },
    },
    "WOMENS WETSUITS": {
      "4": {"height-min": 155, "height-max": 166, "weight-min": 43, "weight-max": 49 },
      "6": {"height-min": 160, "height-max": 169, "weight-min": 47, "weight-max": 52 },
      "8": {"height-min": 164, "height-max": 173, "weight-min": 53, "weight-max": 58 },
      "10": {"height-min": 167, "height-max": 176, "weight-min": 59, "weight-max": 62 },
      "12": {"height-min": 169, "height-max": 178, "weight-min": 63, "weight-max": 67 },
      "14": {"height-min": 172, "height-max": 181, "weight-min": 68, "weight-max": 75 },
    },
    "WOMENS WETSUITS EXTRA": {
      "4": {"height-min": 155, "height-max": 166, "weight-min": 43, "weight-max": 49 },
      "6": {"height-min": 160, "height-max": 169, "weight-min": 47, "weight-max": 52 },
      "6 T": {"height-min": 164, "height-max": 173, "weight-min": 47, "weight-max": 52 },
      "8 S": {"height-min": 160, "height-max": 169, "weight-min": 53, "weight-max": 58 },
      "8": {"height-min": 164, "height-max": 173, "weight-min": 53, "weight-max": 58 },
      "8 T": {"height-min": 167, "height-max": 176, "weight-min": 53, "weight-max": 58 },
      "10 S": {"height-min": 164, "height-max": 173, "weight-min": 59, "weight-max": 62 },
      "10": {"height-min": 167, "height-max": 176, "weight-min": 59, "weight-max": 62 },
      "10 T": {"height-min": 169, "height-max": 178, "weight-min": 59, "weight-max": 62 },
      "12 S": {"height-min": 167, "height-max": 176, "weight-min": 63, "weight-max": 67 },
      "12": {"height-min": 169, "height-max": 178, "weight-min": 63, "weight-max": 67 },
      "12 T": {"height-min": 172, "height-max": 181, "weight-min": 68, "weight-max": 75 },
      "14": {"height-min": 172, "height-max": 181, "weight-min": 68, "weight-max": 75 },
      "16 S": {"height-min": 172, "height-max": 181, "weight-min": 76, "weight-max": 84 },
    },
    "KIDS WETSUITS": {
      "6": {"height-min": 123, "height-max": 128, "weight-min": 25, "weight-max": 30},
      "8": {"height-min": 128, "height-max": 133, "weight-min": 28, "weight-max": 33},
      "10": {"height-min": 133, "height-max": 143, "weight-min": 33, "weight-max": 38},
      "12": {"height-min": 143, "height-max": 153, "weight-min": 39, "weight-max": 43},
      "14": {"height-min": 153, "height-max": 163, "weight-min": 44, "weight-max": 53},
      "16": {"height-min": 163, "height-max": 173, "weight-min": 54, "weight-max": 62},
    }
  }

  const size_calculator_data = all_size_calculator_data[window_api_data.product_type]
  
  const size_swatches = {}
  const size_swatches_domlist = document.getElementsByClassName('block-swatch')
  for (let i=0; i<size_swatches_domlist.length; i++) {
    const span_el = size_swatches_domlist[i].querySelector('span');
    const text_value = span_el.textContent;
    size_swatches[text_value] = size_swatches_domlist[i]
  }

  const size_calculator_link_el = document.createElement('div');
  size_calculator_link_el.className = 'size_calculator_link' 
  previous_cont.after(size_calculator_link_el)

  const size_calculator_el = document.createElement('div');
  size_calculator_el.className = 'size_calculator'
  size_calculator_link_el.after(size_calculator_el)
  
  const inputs_cont_el = document.createElement('div')
  const weight_cont_el = document.createElement('div')
  const height_cont_el = document.createElement('div')
  const weight_label_el = document.createElement('div')
  const weight_input_el = document.createElement('input')
  const height_label_el = document.createElement('div')
  const height_input_el = document.createElement('input')
  const size_recommendation_disclaimer_el = document.createElement('div')
  const no_recommendation_el = document.createElement('div')
  const recommendation_el = document.createElement('div')

  size_calculator_link_el.innerText = 'show size calculator'

  weight_cont_el.className = 'size_calc_weight_cont'
  height_cont_el.className = 'size_calc_height_cont'
  if (size_scale == 'Metric') {
    weight_label_el.innerText = "Weight (kg): "
    height_label_el.innerText = "Height (cm): "
  }
  else {
    weight_label_el.innerText = "Weight (lbs): "
    height_label_el.innerText = "Height (in): "
  }
  weight_label_el.style.display = 'inline-block'
  height_label_el.style.display = 'inline-block'
  weight_input_el.style.padding = '8px'
  height_input_el.style.padding = '8px'
  weight_input_el.style.border = 'none'
  height_input_el.style.border = 'none'
  weight_input_el.style.borderBottom = '1px solid #000'
  height_input_el.style.borderBottom = '1px solid #000'
  weight_input_el.style.width = '49px'
  height_input_el.style.width = '49px'
  weight_input_el.style.margin = '0 8px'
  height_input_el.style.margin = '0 8px'
  weight_input_el.style.marginRight = '42px'
  weight_input_el.style.textAlign = 'center'
  height_input_el.style.textAlign = 'center'
  inputs_cont_el.appendChild(weight_cont_el)
  inputs_cont_el.appendChild(height_cont_el)
  weight_cont_el.appendChild(weight_label_el)
  weight_cont_el.appendChild(weight_input_el)
  height_cont_el.appendChild(height_label_el)
  height_cont_el.appendChild(height_input_el)
  size_calculator_el.appendChild(inputs_cont_el)

  if ((window_api_data.product_title && window_api_data.product_title.includes('Womens')) || (window_api_data.product_type && window_api_data.product_type == "WOMENS WETSUITS")) {
    size_recommendation_disclaimer_el.innerHTML = "* This is a recommended size only. Please now <a href='"+window_api_data.root_url+"/pages/size-chart'>click this hyperlink to our size chart</a> and check your height and weight - <strong>we suggest opting for a size up if you’re in the higher end of the weight range and you're unfamiliar with how our wetsuits fit</strong>. If you have any queries please <a href='"+contact_url+"'>contact customer service</a>."
  } else {
    size_recommendation_disclaimer_el.innerHTML = "* This is a recommended size only. Please now <a href='"+window_api_data.root_url+"/pages/size-chart'>click this hyperlink to our size chart</a> and check your height and weight - we suggest opting for a size up if you’re in the higher end of the weight range and you're unfamiliar with how our wetsuits fit. If you have any queries please <a href='"+contact_url+"'>contact customer service</a>."
  }

  size_recommendation_disclaimer_el.style.color = '#666'
  size_recommendation_disclaimer_el.style.margin = '8px 0 20px'
  size_recommendation_disclaimer_el.style.lineHeight = '1.4'
  size_calculator_el.appendChild(size_recommendation_disclaimer_el)

  recommendation_el.style.margin = '0 0 20px'
  size_calculator_el.appendChild(recommendation_el)
  
  no_recommendation_el.innerHTML = "Sorry we are having difficulty determining your size.<br>Please <a href='"+contact_url+"'>contact customer service</a>."
  no_recommendation_el.style.color = '#666'
  no_recommendation_el.style.margin = '8px 0 30px'
  no_recommendation_el.style.lineHeight = '1.4'
  size_calculator_el.appendChild(no_recommendation_el)



  // Validate size_calculator_data

  if (!size_calculator_data) {
    size_calculator_link_el.innerHTML = "size chart"
    size_calculator_link_el.addEventListener('click', function () {
      window.location = window_api_data.root_url + '/pages/size-chart/'
    })
    return
  }

  const valid_size_recommendations = []

  const sizes = Object.keys(size_calculator_data)

  for (let i=0; i<sizes.length; i++) {
    const x = size_calculator_data[sizes[i]]
    if (
      Number.isInteger(x['height-max']) &&
      Number.isInteger(x['height-min']) &&
      Number.isInteger(x['weight-max']) &&
      Number.isInteger(x['weight-min']) &&
      size_swatches[sizes[i]]
    ) {
      valid_size_recommendations.push(sizes[i])
    }
  }

  if (valid_size_recommendations.length == 0) {
    size_calculator_link_el.innerHTML = "size chart"
    size_calculator_link_el.addEventListener('click', function () {
      window.location = window_api_data.root_url + '/pages/size-chart/'
    })
    return
  }

  let size_calculator_is_visible = false

  function toggle_visibility () {
    if (!size_calculator_is_visible) {
      size_calculator_el.style.display = 'block'
      size_calculator_link_el.innerHTML = 'hide size calculator'
      size_calculator_is_visible = true
    }
    else {
      size_calculator_el.style.display = 'none'
      size_calculator_link_el.innerHTML = 'show size calculator'
      size_calculator_is_visible = false
    }
  }
  size_calculator_link_el.addEventListener('click', toggle_visibility)

  var recommended_size = valid_size_recommendations[Math.floor((valid_size_recommendations.length-1)/2)]
  weight_input_el.value = Math.round((size_calculator_data[recommended_size]['weight-max'] + size_calculator_data[recommended_size]['weight-min']) / 2)
  height_input_el.value = Math.round((size_calculator_data[recommended_size]['height-max'] + size_calculator_data[recommended_size]['height-min']) / 2)

  if (size_scale == 'Imperial') {
     weight_input_el.value = Math.round(weight_input_el.value / 0.45359237)
     height_input_el.value = Math.round(height_input_el.value / 2.54)
  }

  function handle_input_change () {
    var selected_weight = weight_input_el.value
    var selected_height = height_input_el.value

    if (size_scale == 'Imperial') {
       selected_weight = Math.round(selected_weight * 0.45359237)
       selected_height = Math.round(selected_height * 2.54)
    }
    const recommended_sizes = []
    for (let i=0; i<valid_size_recommendations.length; i++) {
      const size = valid_size_recommendations[i]
      if (
        selected_weight>=size_calculator_data[size]['weight-min'] &&
        selected_weight<=size_calculator_data[size]['weight-max'] &&
        selected_height>=size_calculator_data[size]['height-min'] &&
        selected_height<=size_calculator_data[size]['height-max']
      ) {
        recommended_sizes.push(size)
      }
    }

    if (recommended_sizes.length) {
      recommendation_el.style.display = 'block'
      recommendation_el.innerText = 'Recommended size*: '
      for (let i=0; i<recommended_sizes.length; i++) {
        var recommended_value_el = document.createElement('div')
        recommended_value_el.className = 'size_calc_swatch'
        recommended_value_el.style.marginLeft = '8px'
        recommended_value_el.innerText = recommended_sizes[i]
        if (size_swatches[recommended_size].className.indexOf('soldout') != -1) {
          recommended_value_el.classList.add('soldout')
        }
        else {
          recommended_value_el.classList.remove('soldout')
        }
		    recommendation_el.appendChild(recommended_value_el)
        recommended_value_el.addEventListener('click', function () {
          size_swatches[recommended_sizes[i]].click()
          toggle_visibility()
        })
        
        size_recommendation_disclaimer_el.style.display = 'block'
        no_recommendation_el.style.display = 'none'
      }
    }
    else {
      recommendation_el.innerText = ''
      recommendation_el.style.display = 'none'
      size_recommendation_disclaimer_el.style.display = 'none'
      no_recommendation_el.style.display = 'block'
    }        
  }

  weight_input_el.addEventListener('keyup', handle_input_change)
  height_input_el.addEventListener('keyup', handle_input_change)

  handle_input_change()
}

window.render_size_calculator = render_size_calculator;

})()
